import React from "react";
import styled from "styled-components";

const WIDTH = 200;

const StyledActiveFilter = styled.div`
  position: fixed;
  top: calc(100vh - 50px);
  width: ${WIDTH}px;
  background: ${props => props.theme.colors.gray2};
  border: 2px solid ${props => props.theme.colors.gray1};
  left: calc(50vw - ${WIDTH / 2}px);
  border-radius: 20px;
  text-align: center;
  padding: 0.3rem;
  font-size: 0.85rem;
  display: none;
  line-height: 1.2;

  &.open {
    display: block;
  }
`;

interface Props {
  filters: string[];
}

const ActiveFilter: React.FC<Props> = ({ filters }) => {
  const isOpen = !!filters.length;
  return (
    <StyledActiveFilter className={isOpen ? "open" : ""}>{isOpen && <>{filters.join(", ")}</>}</StyledActiveFilter>
  );
};

export default ActiveFilter;
